export default __webpack_public_path__ + "static/media/RJMGsite.b8877dcc.png";